module.exports = __webpack_public_path__ + "static/img/weiBoCode02.0df488a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/App/weiBoCode02.png
// module id = Kma7
// module chunks = 1